export const ANALYTICS_POLLING_INTERVAL_MS = 50;
export const MAX_ANALYTICS_RETRIES = 100;
